import LinearProgress from '@mui/material/LinearProgress';
import React, {useContext, useEffect, useState} from "react";
import strings from "../../../localization";
import DrawerContext from "../../../Context/DrawerContext";
import {useForm} from "react-hook-form";
import {Paper} from "@mui/material";
import DealForm from "../../../Components/Forms/Pages/CRM/Deal/DealForm";
import { getCurrencies } from "../../../Util/SiteDataUtil";
import { getPartners } from "../../../Services/CRM/PartnerService";
import { getPipelinesByType } from "../../../Services/Company/PipelineService";
import { getDealTypes } from "../../../Services/CRM/DealTypeService";
import { getDealPriorityList } from "../../../Services/CRM/DealPriorityService";
import { addDeal } from "../../../Services/CRM/DealService";
import { useSelector } from "react-redux";
import SnackbarContext from "../../../Context/SnackbarContext";
import { getPipelineStages } from '../../../Services/Company/PipelineStageService';
import PipelineType from '../../../Constants/Company/PipelineType';
import ViewType from '../../../Constants/Finance/ViewType';
import PartnerType from '../../../Constants/CRM/PartnerType';
import { getDealSources } from '../../../Services/CRM/DealSourceService';

const formRules = {
    'name': {required: true},
}

const AddDeal = (props) => {
    const {setDrawerTitle} = useContext(DrawerContext);
    const { showMessage } = useContext(SnackbarContext);
    const form = useForm({
        defaultValues: {
            closeDate: new Date()
        }
    });
    const {data, control, handleSubmit, getValues, setValue, formState: {errors}} = form;
    const [showLoader, setShowLoader] = useState(false);
    const siteData = useSelector((state) => state.siteData);
    const [partners, setPartners] = useState(0);
    const [pipeLines, setPipeLines] = useState(0);
    const [pipeLineStages, setPipeLineStages] = useState(0);
    const [dealTypes, setDealTypes] = useState(0);
    const [dealPriority, setDealPriority] = useState(0);
    const [currencies, setCurrency] = useState(0);
    const [dealSources, setDealSources] = useState([]);

    useEffect(() => {
        setDrawerTitle(strings.pages.crm.deal.addDeal.pageTitle);
    });

    useEffect(() => {
        fetch();
        fetchPartners();
        fetchDealTypes();
        fetchDealPriority();
        fetchDealSources();
    }, [])

    useEffect(() => {
        if(props.viewType == ViewType.PIPELINE){

            setValue('pipeLine',props.pipeline);

            getPipelineStages({pipelineId: props.pipeline?.id}).then(response => {
                if(!response.ok || !response){
                    return;
                }
                setPipeLineStages(response.data)
            });
        }
    },[props.viewType])

    const fetch = () => {
        getPipelinesByType({
            type: PipelineType.CRM
            }).then(response =>{
            if (!response || !response.ok){
                return
            }
            setPipeLines(response.data.pipelines)
        });

        setCurrency(getCurrencies(siteData));
    }

    const fetchPartners = (term = '') => {
        getPartners({
            partnerType: PartnerType.CUSOMTER,
            term
        }).then(response =>{
            if (!response || !response.ok){
                return
            }
            setPartners(response.data.result)
        });
    }

    const fetchDealTypes = (term = '') => {
        getDealTypes({term}).then(response =>{
            if (!response || !response.ok){
                return
            }
            setDealTypes(response.data.result)
        });
    }

    const fetchDealPriority = (term = '') => {
        getDealPriorityList({term}).then(response =>{
            if (!response || !response.ok){
                return
            }
            setDealPriority(response.data.result)
        });
    }

    const fetchDealSources = (term = '') => {
        getDealSources({term}).then(response => {
            if (!response || !response.ok){
                setDealSources([]);
            }
            setDealSources(response.data.result);
        });
    }

    const onSubmit = (data) => {
        setShowLoader(true);

        addDeal(data).then(response => {
            setShowLoader(false);

            if (!response || !response.ok){
                showMessage(strings.commonMessages.errorAdding, 'error');
                props.onFinish();
                return;
            }

            showMessage(strings.commonMessages.addingSuccessful, 'success');
            props.onFinish();
        });
    }

    const onCancel = () => {
        props.onCancel();
    }

    const onPipeLineChange = (newValue) => {

        if(newValue){
            setValue('pipeLine',newValue)

            getPipelineStages({pipelineId: newValue?.id}).then(response => {
                if(!response.ok || !response){
                    return;
                }
                setPipeLineStages(response.data)
            })
        }
        setValue('pipeLineStage',null)
        setPipeLineStages([])
    }

    return <div className='drawer-form'>
        <Paper className='paper'>
            {
                showLoader &&
                <LinearProgress />
            }
            <DealForm
                control={control} formRules={formRules}
                values={getValues()} setValue={setValue}
                data={data} errors={errors} form={form}
                pipelines={pipeLines} pipeLineStages={pipeLineStages}
                dealTypes={dealTypes} dealPriority={dealPriority}
                currencies={currencies} partners={partners} dealSources={dealSources}
                onPipeLineChange={(newValue)=> onPipeLineChange(newValue)}
                onChangePartnersFilter={fetchPartners} onChangeDealTypesFilter={fetchDealTypes}
                onChangeDealPriorityFilter={fetchDealPriority} onChangeDealSourcesFilter={fetchDealSources}
                onSubmit={handleSubmit(onSubmit)} onCancel={() => onCancel()}
            />
        </Paper>
    </div>
}

export default AddDeal;